// extracted by mini-css-extract-plugin
export default {"accordion-details":"WorkOrderItemsModal_accordion-details__3+SXt","batch-list":"WorkOrderItemsModal_batch-list__VR2gb","prod-img":"WorkOrderItemsModal_prod-img__zNZ1f"};